import Skeleton from '@core/Skeleton';
import { TableCell, TableRow } from '@core/table/core';
import { useTableContext } from '@core/table/features/TableContext';

const LoadingView = () => {
  const { pagination, columns } = useTableContext();
  const { pageSize } = pagination;
  const tableRows = [];

  for (let i = 0; i < pageSize; i++) {
    tableRows.push(
      <TableRow key={`loading-row-${i}`}>
        {columns.map((_, index) => (
          <TableCell key={`loading-cell-${index}`}>
            <Skeleton height={24} variant="rect" />
          </TableCell>
        ))}
      </TableRow>
    );
  }

  return (
    <tbody aria-hidden data-testid="loading-tbody">
      {tableRows}
    </tbody>
  );
};

export default LoadingView;
